type DeferredHandler = () => void | Promise<void>;

export const createDeferredAction = () => {
    let handler: DeferredHandler | undefined;
    let hasRequested = false;
    let hasHandled = false;

    const handleIfReady = () => {
        if (!handler || !hasRequested || hasHandled) {
            return;
        }

        hasHandled = true;
        const currentHandler = handler;
        handler = undefined;
        void currentHandler();
    };

    return {
        register(nextHandler: DeferredHandler) {
            if (handler || hasHandled) {
                return;
            }

            handler = nextHandler;
            handleIfReady();
        },
        request() {
            if (hasRequested || hasHandled) {
                return;
            }

            hasRequested = true;
            handleIfReady();
        },
    };
};

export const myMessagesDeferredPrebidLoad = createDeferredAction();
